import { render, staticRenderFns } from "./SortQuestionsModal.vue?vue&type=template&id=2a540ab8&scoped=true&"
import script from "./SortQuestionsModal.vue?vue&type=script&lang=js&"
export * from "./SortQuestionsModal.vue?vue&type=script&lang=js&"
import style0 from "./SortQuestionsModal.vue?vue&type=style&index=0&id=2a540ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a540ab8",
  null
  
)

export default component.exports